import { useEffect } from 'react';
import { selectCurrentZoomLevel } from '../../reducers/zoomSlice';
import { canvasGenerationSelectors } from '../../reducers/canvasGenerationSlice';
import { TRIGGER_ZOOM_EVENT } from '../constants';
import { useAppSelector } from '../../reducers/rootReducer';

const useTriggerZoom = (zoomTrigger: (ev) => void) => {
  const currentZoomLevel = useAppSelector(selectCurrentZoomLevel);
  const dynamicZoomLevelsRanges = useAppSelector(
    canvasGenerationSelectors.selectRangesByZoomLevel,
  );

  useEffect(() => {
    document.addEventListener(TRIGGER_ZOOM_EVENT, zoomTrigger);

    return () => {
      document.removeEventListener(TRIGGER_ZOOM_EVENT, zoomTrigger);
    };
  }, [currentZoomLevel, dynamicZoomLevelsRanges]);
};

export const dispatchZoomTrigger = (ev) => {
  document.dispatchEvent(
    new CustomEvent(TRIGGER_ZOOM_EVENT, {
      detail: ev,
    }),
  );
};

export default useTriggerZoom;
